<template>
  <div class="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-5">
    <div
      v-for="industry in industries"
      :key="industry.name"
      class="flex flex-col items-center text-center p-6 rounded-xl bg-gray-800 bg-opacity-40 border border-gray-700 hover:border-brand-primary hover:bg-opacity-60 transition-all duration-300 group"
    >
      <div class="w-14 h-14 rounded-full bg-brand-primary bg-opacity-10 flex items-center justify-center mb-4 group-hover:bg-opacity-20 transition-all">
        <component :is="getIcon(industry.icon)" class="w-7 h-7 text-brand-primary" />
      </div>
      <h3 class="text-lg font-semibold text-white mb-2">{{ industry.name }}</h3>
      <p class="text-sm text-gray-400 leading-relaxed">{{ industry.description }}</p>
    </div>
  </div>
</template>

<script setup>
import { h } from 'vue';

defineProps({
  industries: {
    type: Array,
    required: true,
    validator: (industries) =>
      industries.every((i) => i.name && i.icon && i.description),
  },
});

const ICON_PATHS = {
  home: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
  health: 'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z',
  fitness: 'M13 10V3L4 14h7v7l9-11h-7z',
  restaurant: 'M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z',
  car: 'M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0',
};

function getIcon(name) {
  const d = ICON_PATHS[name] || ICON_PATHS.home;
  return (props) =>
    h(
      'svg',
      { ...props, fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24' },
      [
        h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d,
        }),
      ],
    );
}
</script>
